document.getElementById('expedited-shipping-form').addEventListener('submit', function(e) {
    e.preventDefault();

    var deliveryDate = document.getElementById('delivery-date').value;
    var customerNotes = document.getElementById('customer-notes').value;
    var phoneNumber = '12142455324'; // Replace with your WhatsApp number in the format 1234567890
    var productUrl = window.location.href; // Get the current product page URL

    if (deliveryDate) {
        var message = `Hello, I'd like to request expedited shipping.
        \nProduct URL: ${productUrl}
        \nRequired Delivery Date: ${deliveryDate}
        \nNotes: ${customerNotes ? customerNotes : 'No special notes'}`;

        var whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
        window.open(whatsappUrl, '_blank');
    } else {
        alert('Please select a delivery date.');
    }
});
